const CONTENT_STACK_CLASS_NAME = 'relative isolate z-0'
const PROTECTED_CONTENT_CLASS_NAME = `${CONTENT_STACK_CLASS_NAME} mx-[40px] mt-[20px] lg:mx-[96px]`
// Se exporta también para el banner del Shell: con el menú mobile abierto se oculta igual
// que el contenido (PBI 81906).
export const MOBILE_MENU_OPEN_CLASS_NAME = 'hidden min-[1025px]:block'

// Rutas que manejan sus propios márgenes porque tienen algún elemento a ancho
// completo: en selección de cuenta, la banda "Estás en la cuenta" se extiende
// más allá del contenido.
const RUTAS_ANCHO_COMPLETO = new Set(['/', '/menu-clientes', '/seleccion-cuenta'])

export function getProtectedContentClassName(pathname, mobileMenuOpen = false) {
  const contentClassName = RUTAS_ANCHO_COMPLETO.has(pathname)
    ? `${CONTENT_STACK_CLASS_NAME} w-full`
    : PROTECTED_CONTENT_CLASS_NAME

  return mobileMenuOpen ? `${contentClassName} ${MOBILE_MENU_OPEN_CLASS_NAME}` : contentClassName
}
